

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  appVersion: '1.0.0-SNAPSHOT',
  production: false,
  baseURLAPI: 'http://163.172.171.69:8080/',
  //baseURLAPI: 'http://localhost:8081/',
  apiVersion: 'api/',
  clientId:'test',
  secret:'test'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
